/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Copilot_Placeholder4Inputs */

const zh_landing_copilot_placeholder4 = /** @type {(inputs: Landing_Copilot_Placeholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为八年级学生做一份一元一次方程练习卷`)
};

const en_landing_copilot_placeholder4 = /** @type {(inputs: Landing_Copilot_Placeholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a worksheet on solving linear equations for Grade 8`)
};

const es_landing_copilot_placeholder4 = /** @type {(inputs: Landing_Copilot_Placeholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseña una hoja de ejercicios sobre ecuaciones lineales para 8.º grado`)
};

/**
* | output |
* | --- |
* | "Build a worksheet on solving linear equations for Grade 8" |
*
* @param {Landing_Copilot_Placeholder4Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_copilot_placeholder4 = /** @type {((inputs?: Landing_Copilot_Placeholder4Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Copilot_Placeholder4Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_copilot_placeholder4(inputs)
	if (locale === "en") return en_landing_copilot_placeholder4(inputs)
	return es_landing_copilot_placeholder4(inputs)
});